<template>
    <div>
          <div class="detail-card">
            <h6>Discounts And Coupons</h6>
            <div style="width:100%;">
              <!--view--discounts-->
              <div v-if="!(product_details.setProductDiscount || product_details.setProductItemDiscount) && !product_details.editDiscount">
                <div>
                  <div style="float: left; width: 45%;">
                    <p v-if="product_details.viewProductItemsDiscounts" class="sp-app-default-color">
                      <a class="card-link" @click="setProductComponent('viewProductDiscounts','','')">
                        General Product Discount/Coupons
                      </a></p>
                    <p v-else style="text-decoration: underline;" class="sp-app-default-color">General Product Discount/Coupons</p>
                  </div>
                  <div style="float: right; width: 45%;">
                    <p v-if="!product_details.viewProductItemsDiscounts" class="sp-app-default-color">
                      <a class="card-link" @click="setProductComponent('viewProductItemsDiscounts','','')">Product Groups Discount/Coupons</a></p>
                    <p v-else style="text-decoration: underline;"  class="sp-app-default-color">Product Groups Discount/Coupons</p>
                  </div>
                  <div style="clear: both;"></div>
                </div>
                
                <!--view-general-products-discounts-->
                <div v-if="!product_details.viewProductItemsDiscounts">
                  <div v-if="((product.product_only_coupon_discount_count > 0) && (Object.keys(product.product_items[0].product_item_discounts).length > 0))" style="">
                    <div v-for="(dc,dcdex) in product.product_items[0].product_item_discounts" :key="dcdex">
                      <div class="card card-flat-pad" v-if="(dc.discount_type == 4)" style="border: #f7f7f7 solid !important;">
                        <div style="float:left; width:90%;">
                            <div>
                            <p>{{dc.discount_percentage}}% Discount</p>
                            <div style="clear:both;"></div>
                            </div>
                        </div>
                        <div style="float:right;">
                            <div>
                            <a v-if="menu_tab_inner_view['DCS'+dcdex]" style="cursor:pointer; color: inherit;" @click="setMenuTabInnerView('')">
                                <div class="">
                                <i class="fa fa-angle-down"></i>
                                </div>
                            </a>
                            <a v-else style="cursor:pointer; color: inherit;" @click="setMenuTabInnerView('DCS'+dcdex)">
                                <div class="">
                                <i class="fa fa-angle-down"></i>
                                </div>
                            </a>
                            </div>
                        </div>
                        <div style="clear: both;"></div>
                        <div v-if="menu_tab_inner_view['DCS'+dcdex]">
                            <div>
                            <!-- <p v-if="(dc.discount_type == 5)"><b>Product Item Discount</b></p>
                            <p v-if="(dc.discount_type == 4)"><b>General Product Discount</b></p>
                            <p v-if="!(dc.discount_type == 4) && !(dc.discount_type == 5)"><b>General Sellpoint Discount</b></p> -->
                            <div style="background:#f8e7ce; text-align: center;">
                                <p v-if="dc.discount_coupon == 'D'"><b>Discount</b></p>
                                <p v-if="dc.discount_coupon == 'C'"><b>Coupon:</b> (Code: {{dc.discount_coupon_code}} )</p>
                            </div>
                            <!-- <p v-if="dc.discount_product_item != product_item.product_item_id"><b>Type: </b>{{dc.discount_category_name}}</p> -->
                            <p><b>%Discount: </b>{{dc.discount_percentage}}%</p>
                            <p><b>Minimum Quantity: </b>{{dc.discount_min_quantity}}</p>
                            <p><b>Start Date: </b>{{dc.discount_start_date}}</p>
                            <p><b>End Date: </b>{{dc.discount_end_date}}</p>
                            <p><b>Status: </b>{{dc.discount_status}}</p>
                            <!-- <p v-if="dc.discount_product_item == productItem.product_item_id"> -->
                            <div v-if="(dc.discount_type == 4) || (dc.discount_type == 5)"> 
                                <p v-if="dc.discount_status_id == 5" >
                                <a style="cursor:pointer; text-decoration:underline; font-size:13px; color:#448aff;" @click="setProductComponent('editDiscount','',dc)" title="Edit">
                                    Edit Discount</a> &nbsp;&nbsp;&nbsp;
                                <a style="cursor:pointer; text-decoration:underline; font-size:13px; color:#448aff;" @click="setProductComponent('deactivateDiscount',product.product_items[0],dc)" title="De-Activate">
                                    Deactivate Discount</a> 
                                <div class="loading-sm" v-if="action_loading && (product.product_items[0].product_item_id == product_item.product_item_id)"></div>   
                                </p>
                            </div>
                            <p v-else style="color:#ff0000;">Edit/Deactivate at Business Settings</p>
                            <hr/>
                            </div>
                        </div>
                      </div>
                      <div v-else style="display:none"></div>
                    </div>
                  </div>
                  <div v-else>
                    <p style="color:#ff0000;">No set general product discount or coupon</p>
                  </div>
                  <button style="line-height:2em;" class="btn sp-button-02 sp-button-sm" @click="setProductComponent('setProductDiscount','','')">Set New Product Discount Or Coupon</button>
                </div>
                <!--./view-general-products-discounts-->
  
                <!--view-products-items-discounts-->
                <div v-if="product_details.viewProductItemsDiscounts" style="margin-top:1em;">
                  <div style="">
                    <h6 class="pull-left" style="text-transform:uppercase; font-size: 14px;">Items in this Product</h6>
                    <button style="line-height:1.2;" class="btn btn-xs v-tiny-btn sp-button-02 sp-button-sm pull-right" @click="setComponent('reset-edit','')">Close</button>
                    <div class="clearfix"></div>
                  </div>
                  <div v-for="productItem in product.product_items" :key="productItem.product_item_id" style="border-bottom: dashed #f4f6f8; padding: 5px; margin-bottom: 1em;">
                    <!--product--items--details-->
                    <div class="items-list-tiny" style="display:inline; font-size: 12px;">
                      <div style="float: left; width: 20%;">
                        <li v-if="productItem.product_item_group_is_color_image == 'IMG'">
                          <img v-if="(productItem.product_item_group_image && (productItem.product_item_group_image  != 'error'))" :src="productItem.product_item_group_image " style="height:30px;"/>
                          <img v-else src="/static/assets/images/dummy-image.png" style="height:50px;"/>
                        </li>
                        <li v-if="productItem.product_item_group_is_color_image == 'COL'">
                          <a class="btn box-color-cube" v-bind:style="{background: productItem.product_item_group_color}"> </a>
                        </li> 
                      </div>
                      <div style="float: right; width: 80%;">
                        <p>
                          <span v-if="product.product_service == 'P'  && (productItem.product_item_size)"><b>{{productItem.product_item_size}}</b></span>
                          <span v-if="product.product_service == 'S' && (productItem.product_item_service_tag)"><b>{{productItem.product_item_service_tag}}</b></span>
                          <span v-if="product.product_service == 'P'"><span>Wt(kg):</span>{{productItem.product_item_weight}}</span>
                          <span><span v-if="productItem.product_item_actual_price != 0"><span>Price:</span>{{productItem.product_item_actual_price}}</span>
                            <span v-else><span>Price:</span>{{productItem.product_item_price}}</span></span>
                          <span><span>Qty:</span>{{productItem.product_item_quantity}}</span>
                        </p>
                      </div>
                      <div style="clear: both;"></div>
                    </div>
                    <!--./product--items--details-->
                    <div style="margin-top: 0.6em;">
                      <!--view-itm-discounts-->
                      <div v-for="(dc,ptdcdex) in productItem.product_item_discounts" :key="ptdcdex">
                        <div class="card card-flat-pad" v-if="(dc.discount_type == 5)" style="border: #f7f7f7 solid !important;">
                            <div style="float:left; width:90%;">
                            <div>
                                <p>{{dc.discount_percentage}}% Discount</p>
                            <div style="clear:both;"></div>
                            </div>
                            </div>
                            <div style="float:right;">
                            <div>
                                <a v-if="menu_tab_inner_view['PTDCS'+ptdcdex]" style="cursor:pointer; color: inherit;" @click="setMenuTabInnerView(''); setProductComponent('viewProductItemsDiscounts','','');">
                                <div class="">
                                    <i class="fa fa-angle-down"></i>
                                </div>
                                </a>
                                <a v-else style="cursor:pointer; color: inherit;" @click="setMenuTabInnerView('PTDCS'+ptdcdex); setProductComponent('viewProductItemsDiscounts','','');">
                                <div class="">
                                    <i class="fa fa-angle-down"></i>
                                </div>
                                </a>
                            </div>
                            </div>
                            <div style="clear: both;"></div>
                            <div v-if="menu_tab_inner_view['PTDCS'+ptdcdex]">
                            <div>
                                <!-- <p v-if="(dc.discount_type == 5)"><b>Product Item Discount</b></p>
                                <p v-if="(dc.discount_type == 4)"><b>General Product Discount</b></p>
                                <p v-if="!(dc.discount_type == 4) && !(dc.discount_type == 5)"><b>General Sellpoint Discount</b></p> -->
                                <div style="background:#d1ddf1; text-align: center;">
                                <p v-if="dc.discount_coupon == 'D'"><b>Discount</b></p>
                                <p v-if="dc.discount_coupon == 'C'"><b>Coupon:</b> (Code: {{dc.discount_coupon_code}} )</p>
                                </div>
                                <!-- <p v-if="dc.discount_product_item != product_item.product_item_id"><b>Type: </b>{{dc.discount_category_name}}</p> -->
                                <p><b>%Discount: </b>{{dc.discount_percentage}}%</p>
                                <p><b>Minimum Quantity: </b>{{dc.discount_min_quantity}}</p>
                                <p><b>Start Date: </b>{{dc.discount_start_date}}</p>
                                <p><b>End Date: </b>{{dc.discount_end_date}}</p>
                                <p><b>Status: </b>{{dc.discount_status}}</p>
                                <!-- <p v-if="dc.discount_product_item == productItem.product_item_id"> -->
                                <div v-if="(dc.discount_type == 4) || (dc.discount_type == 5)"> 
                                <p v-if="dc.discount_status_id == 5" >
                                    <a style="cursor:pointer; text-decoration:underline; font-size:13px; color:#448aff;" @click="setProductComponent('editDiscount','',dc)" title="Edit">
                                    Edit Discount</a> &nbsp;&nbsp;&nbsp;
                                    <a style="cursor:pointer; text-decoration:underline; font-size:13px; color:#448aff;" @click="setProductComponent('deactivateDiscount',product.product_items[0],dc)" title="De-Activate">
                                    Deactivate Discount</a> 
                                    <div class="loading-sm" v-if="action_loading && (product.product_items[0].product_item_id == product_item.product_item_id)"></div>   
                                </p>
                                </div>
                                <p v-else style="color:#ff0000;">Edit/Deactivate at Business Settings</p>
                                <hr/>
                            </div>
                            </div>
                            <div style="clear: both;"></div>
                        </div>
                        <div v-else style="display:none"></div>
                      </div>
                      <div>
                        <!-- <p v-if="productItem.product_item_only_coupon_discount_count == 0" style="color:#00a2ff;">No set discount or coupon</p> -->
                        <a class="sp-app-default-color" style="font-size: 13px; line-height:1.2; text-decoration: underline; float: right;" @click="setProductComponent('setProductItemDiscount','productitem',productItem)">
                          <!-- <span style="padding: 0.3em; border-radius: 50%; width: 25px; height: 25px; color: #f5f5f5; font-size: 16px;" class="sp-app-default-background-color">+</span> -->
                          <span style="font-size: 16px; font-weight: bolder;" class="sp-app-default-color">+</span> New Discount / Coupon</a>
                      </div>
                      <!--./view-item-discounts-->
                      <div style="clear: both;"></div>
                    </div>
                  </div>
                </div>
                <!--./view-products-items-discounts-->
              </div>
              <!--./view--discounts-->
              <!-- Add/Set Discounts -->
                <div v-if="product_details.setProductDiscount || product_details.setProductItemDiscount">
                  <!-- <h5 style="font-size:13px">Set New Discount or Coupon</h5> -->
                  <div class="" style="padding-left:0">
                    <!-- PAUSED - NO RESTRICTIONS <div class="form-group" v-if="((product.product_discounts_active != 1) || (product_item.product_item_discounts_active != 1))"> -->
                    <div class="form-group">
                      <label v-if="product_details.setProductDiscount">Set Product Coupon Or Discount</label>
                      <label v-if="product_details.setProductItemDiscount">Set Product Item Coupon Or Discount</label>
                      <select class="form-control" v-model="discount_coupon.is_discount_coupon">
                        <option :value="undefined">Select</option>
                        <option value="D">Discount</option>
                        <option value="C">Coupon</option>
                      </select>
                    </div>
                    <div v-if="((product.product_discounts_active == 1) || (product_item.product_item_discounts_active == 1))">
                      <p style="color:#ff0000;">You have an active Discount</p>
                    </div>
                    <div class="form-group" style="display: none;">
                      <label><input type="checkbox" v-model="discount_coupon_is_direct">
                        Direct Discount (for a particular user)  ?</label>
                    </div>
  
                    <div class="form-group" v-if="discount_coupon_is_direct">
                      <label>Enter username </label>
                      <input type="text" class="form-control" v-model="discount_coupon.discount_username"/>
                    </div>
  
                    <div class="form-group">
                      <!-- <label v-if="sellpoint.business_discounts_active != 1">Percentage Discount</label> -->
                      <label>Percentage Discount</label>
                      <input class="form-control" type="number" min="1" max="100" v-model="discount_coupon.discount_percentage"/>
                    </div>
                    <div class="form-group">
                      <label>Minimum Quantity</label>
                      <input class="form-control" type="number" v-model="discount_coupon.discount_min_quantity"/>
                    </div>
                    <div class="form-group">
                      <label>Start Date</label>
                      <input class="form-control" type="date" v-model="discount_coupon.discount_start_date"/>
                    </div>
                    <div class="form-group">
                        <label>End Date</label>
                        <input class="form-control" type="date" v-model="discount_coupon.discount_end_date"/>
                    </div>
                    <div class="form-group">
                      <div class="loading-sm" v-if="action_loading"></div>
                      <p style="color:#ff0000;">{{data_processing_message}}</p>
                      <button :disabled="disable_btn" style="line-height: 1.2;" class="btn sp-button-02" @click="setDiscountsAndCoupons()">SET</button>
                    <button style="line-height:1.2;" class="btn sp-button-02" @click="setComponent('reset-edit','')" >Cancel</button>
                    </div>
                  </div>
                  <div class="" style="display:none;">
                    <p style="color:#363535; line-height: 1.2;">Note that you can only set one Sellpoint Discount at a time.
                      If you want to end an existing discount click on "Stop Discount" button on the Discount.
                    </p>
                  </div>
                </div>
              <!-- ./ Add/Set Discounts -->
  
                <!-- Edit Discounts -->
                <div class="col-md-12" v-if="product_details.editDiscount">
                    <h5 style="font-size:13px">Edit Discount</h5>
                    <div class="" style="padding-left:0">
                      <div class="form-group">
                        <label>Percentage Discount</label>
                        <input class="form-control" type="number" min="1" max="100" v-model="discount_coupon.discount_percentage"/>
                      </div>
                      <div class="form-group">
                        <label>Minimum Quantity</label>
                        <input class="form-control" type="number" v-model="discount_coupon.discount_min_quantity"/>
                      </div>
                      <div class="form-group">
                        <label>Start Date: {{discount_coupon.discount_start_date}}</label>
                        <input class="form-control" type="datetime-local" v-model="discount_coupon.discount_start_date"/>
                      </div>
                      <div class="form-group">
                        <label>End Date: {{discount_coupon.discount_end_date}}</label>
                        <input class="form-control" type="datetime-local" v-model="discount_coupon.discount_end_date"/>
                      </div>
                      <div class="form-group">
                        <div class="loading-sm" v-if="action_loading"></div>
                        <p style="color:#ff0000;">{{data_processing_message}}</p>
                        <button :disabled="disable_btn" style="line-height:2em;" class="btn sp-button-02" @click="editDiscountsAndCoupons()">Save</button>
                        <button style="line-height:2em;" class="btn sp-button-02" @click="setComponent('reset-edit','')" >Cancel</button>
                      </div>
                    </div>
                </div>
                <!-- ./-Edit Discounts -->
            </div>
            <br>
          </div>
        </div>
</template>

<style>
 @import url("style.css");
</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
              no_data: true,
            }
        },

        methods: {
            setPage(){
                let self = this;
                localforage.getItem('xvue', function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                        self.product =  value.account.store_sellpoint.store_product;
                    }else{}
                });
           
            },
        },

        components: {},

        created: function(){
            this.setPage();
        }
    }
</script>



// WEBPACK FOOTER //
// ProductDiscounts.vue?34a0915f